import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import CatalistOnlyChip from "@/components/sharedComponents/CatalistOnlyChip";
import { shootConfetti } from "@/components/sharedComponents/confetti";
import DonutChart from "@/components/sharedComponents/DonutChart";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import { formatLargeNumber } from "@/utils/util";

import "@/components/membership/ProcessConfirmation/ProcessConfirmationStyles.css";

function ProcessConfirmation() {
  const [chartData, setChartData] = useState(null);
  const { affiliateFileData, templateData, summaryData } =
    useUpdateDataContext();

  const options = {
    plugins: {
      title: {
        display: true,
        text: "Membership type breakdown:",
        color: "black",
      },
    },
  };

  useEffect(() => {
    if (summaryData.summary?.field_data[0]?.histogram) {
      const histogramData = summaryData.summary.field_data[0].histogram;
      const data = [];
      for (const key in histogramData) {
        data.push({ label: key, value: histogramData[key]["current"] });
      }
      setChartData(data);
    }
    // summaryData.summary.field_data is the only relevant input; reading
    // summaryData on every context update would re-run this effect, but
    // the original was mount-only. Preserve the original behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    shootConfetti();
  }, []);

  return (
    <>
      <Box className="confirmation-container">
        <Typography variant="h6">
          {affiliateFileData.name} has been successfully submitted!
        </Typography>
        <Typography
          sx={{
            color: "red",
            marginBottom: "10px",
            fontStyle: "italic",
            fontSize: "1.2rem",
          }}
        >
          Please allow up to 15 minutes for this submission to be updated in the
          Dashboard
        </Typography>
        <Box className="summary-container">
          <Box>
            <Typography>Processed: {summaryData.processTimestamp}</Typography>
            <Typography>Data file: {affiliateFileData.name}</Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography>Template: {templateData.name}</Typography>{" "}
              {templateData.use === "catalist-only" && <CatalistOnlyChip />}
            </Box>
            <Typography>
              Uploaded Rows: {summaryData.summary.member_rows}
            </Typography>
            <Typography>
              Processing Duration:{" "}
              {new Date(summaryData.processedDuration * 1000)
                .toISOString()
                .slice(11, 19)}
            </Typography>
            <Typography>
              Number of dropped duplicate records: {summaryData.droppedRows}
            </Typography>
            {summaryData.summary.persons ? (
              <Typography>
                Unique persons: {formatLargeNumber(summaryData.summary.persons)}
              </Typography>
            ) : null}
          </Box>

          {templateData.use === "general" && chartData && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <DonutChart data={chartData} options={options} />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}

export default ProcessConfirmation;
